/**
 * Entry point for Chat screen
 * @remarks Exports ChatContainer as default for use in route files
 */

export { default } from "./ChatContainer";
